import React, { useEffect, useState } from 'react';
import {
  Button,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
  useToast,
} from '@chakra-ui/react';
import axios from 'axios';

interface DeleteVariationModalProps {
  isOpen: boolean;
  onClose: () => void;
  variationID: any;
  count: number;
  setCount: any;
}

function DeleteVariationModal({
  isOpen,
  onClose,
  variationID,
  count,
  setCount,
}: DeleteVariationModalProps) {
  let toast = useToast();
  const deleteVariation = async () => {
    const baseurl = process.env.REACT_APP_PAYER_FORM_BASE_URL as string;
    const tokenUrl = process.env.REACT_APP_SCENARIO_TOKEN_URL as string;
    try {
      const tokenResponse = await axios.get(tokenUrl);
      const userdetails = JSON.parse(localStorage.getItem('userdetails') || '');
      let portalid = userdetails[0].portal_Id!;
      if (tokenResponse.data.success) {
        const response = await axios.get(
          baseurl + '/App/api/delete_variation',
          {
            headers: {
              Authorization: `Bearer ${tokenResponse.data.token}`,
            },
            params: {
              variationid: variationID,
              user: portalid,
            },
          }
        );
        setCount(count + 1);
        toast({
          title: 'Success',
          position: 'top',
          description: 'Variation Successfully Deleted!',
          status: 'success',
          duration: 3000,
          isClosable: true,
        });
      } else {
        throw new Error('Failed to retrieve auth token');
      }
    } catch (error) {
      console.error('Error fetching forms:', error);
    }
  };

  return (
    <>
      <Modal isCentered isOpen={isOpen} onClose={onClose} size="xs">
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <Text textAlign="center">
              Do you want to delete this Variation?
            </Text>
          </ModalBody>
          <ModalFooter justifyContent=" center">
            <Button
              onClick={onClose}
              bg="#002677"
              color="white"
              h="30px"
              w="fit-content"
              mr="5px"
            >
              Cancel
            </Button>
            <Button
              bg="#002677"
              color="white"
              h="30px"
              w="fit-content"
              onClick={() => {
                deleteVariation();
                onClose();
              }}
            >
              Confirm
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default DeleteVariationModal;
